import axios from "axios";
import ConfigurationService from "./ConfigurationService";
import Kichiri from "./KichiriService";
import UserService from "./UserService";

const BASE_URL = ConfigurationService.resolveApi().rest;

const FaqService = {
	/**
	 * Fetch all FAQ items
	 * @returns {Promise<Array>}
	 */
	async fetchAll() {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.faq.list({}, {}, authToken);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return [];
	},

	/**
	 * Search FAQ items using AI
	 * @param {Object} params
	 * @param {string} params.query - The search query
	 * @param {string} params.provider - AI provider ("openai")
	 * @param {string} params.model - AI model name
	 * @param {number} params.topN - Number of top results to return
	 * @returns {Promise<Object|null>}
	 */
	async search({ query, provider, model, topN = 5 }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.faq.search({ query, provider, model, topN }, {}, authToken);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	/**
	 * Create a new FAQ item with optional video upload
	 * @param {Object} params
	 * @param {string} params.question
	 * @param {string|null} params.videoTitle
	 * @param {string|null} params.category
	 * @param {string} params.transcriptText
	 * @param {File|null} params.videoFile
	 * @returns {Promise<Object>}
	 */
	async create({ question, videoTitle, category, transcriptText, videoFile }) {
		let { authToken } = UserService.getUserData();

		const formData = new FormData();
		formData.append("question", question);
		if (videoTitle) formData.append("videoTitle", videoTitle);
		if (category) formData.append("category", category);
		formData.append("transcriptText", transcriptText);
		if (videoFile) formData.append("files", videoFile);

		let response = await axios.post(
			`${BASE_URL}/faq/create`,
			formData,
			{
				headers: {
					Authorization: authToken,
					"Content-Type": "multipart/form-data",
				},
			}
		);

		return response.data;
	},
};

export default FaqService;
